/**
 * design_handoff_auth — the "card-level" state swap used by forgot
 * password (link sent), reset password (expired link) and confirm email
 * (verified). Icon disc + heading + body + a row of actions.
 */
import React from "react";
import classNames from "classnames";
import { Icon } from "../../theme/untitled";
import styles from "./AuthStateCard.module.scss";

const AuthStateCard = ({ tone = "success", icon, title, children, actions }) => {
  return (
    <div className={styles.root}>
      <span className={classNames(styles.disc, styles[`disc--${tone}`])}>
        <Icon name={icon} size={22} />
      </span>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.body}>{children}</div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};

export default AuthStateCard;
